'use strict';

var exenv = require('exenv');
const includes = (array, value) => array.indexOf(value) !== -1;
var includes$1 = includes;
const ANDROID_OS = 'android';
const IOS_OS = 'ios';
const LINUX_OS = 'linux';
const MAC_OS = 'mac os';
const WINDOWS_OS = 'windows';
const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
const getOsName = () => {
  var _window, _window2;
  if (!exenv.canUseDOM) return;
  const userAgent = (_window = window) === null || _window === void 0 || (_window = _window.navigator) === null || _window === void 0 ? void 0 : _window.userAgent;
  const platform = (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.navigator) === null || _window2 === void 0 ? void 0 : _window2.platform;
  if (includes$1(macosPlatforms, platform)) return MAC_OS;
  if (includes$1(iosPlatforms, platform)) return IOS_OS;
  if (includes$1(windowsPlatforms, platform)) return WINDOWS_OS;
  if (/Android/.test(userAgent)) return ANDROID_OS;
  if (/Linux/.test(userAgent)) return LINUX_OS;
  return undefined;
};
module.exports = getOsName;
